import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ModelState } from "./model";
import * as fromSentiment from "./model.reducer";

export const selectModelState = createFeatureSelector<ModelState>(
  fromSentiment.modelFeatureKey,
);

export const selectModelsLoading = createSelector(
  selectModelState,
  (state) => state?.loadingModels || state?.loadingVersions || false,
);

export const selectModelLabels = createSelector(selectModelState, (state) =>
  (state?.summaries ?? []).map((s) => s.label),
);

export const selectModelVersions = createSelector(
  selectModelState,
  (state) => state?.versions ?? [],
);

export const selectModels = createSelector(
  selectModelState,
  (state) => state?.summaries ?? [],
);
